const TextElementModel = {
  content: { pl: '', en: '' },
};

export default TextElementModel;
